import { render, staticRenderFns } from "./SportcomplexHome.vue?vue&type=template&id=1cf4fe37&"
import script from "./SportcomplexHome.vue?vue&type=script&lang=js&"
export * from "./SportcomplexHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports